/* EVENTS INVOLVING CHARTS */

function getDefaultChartProps({chart, dashboard}) {
    return {
        widgetId: chart?.id,
        widgetTitle: chart?.title,
        dashboardId: dashboard?.id,
        dashboardTitle: dashboard?.title,
        widgetType: chart.type ? chart.type : 'chart',
    }
}

module.exports = {
    widget_edit_visit: { // visit a chart edit tab
        excludeSuperAdmin: true,
        getProps: getDefaultChartProps
    },
    widget_edit_close: { // close the chart edit tab
        excludeSuperAdmin: true,
        getProps: getDefaultChartProps
    },
    widget_edit_name_change: { // edit chart name from tab
        excludeSuperAdmin: true,
        getProps: getDefaultChartProps
    },
    widget_edit_save_to_dashboard: { // move the widget to dashboard layout from drafts or by clicking save to dashboard button in controll bar
        getProps: getDefaultChartProps
    },
    widget_edit_save_to_drafts: { // move the widget to dashboard drafts by clicking save to drafts button in controll bar
        getProps: getDefaultChartProps
    },
    widget_edit_table_change: { // move the widget to dashboard drafts by clicking save to drafts button in controll bar
        getProps: getDefaultChartProps
    },
}